import { RingFinishEnum } from '@jouzen/ecom-components/v3/enums/ringFinish';
import type { RingFinish } from '@jouzen/ecom-components/v3/types/ringFinish';

import wizardData from '@/app/[locale]/product/_steps/wizardData';
import { RingStyleEnum } from '@/app/enums/RingStyleEnum';
import type { ChargerModel } from '@/app/types/accessory';
import type { RingStyle } from '@/app/types/ring';

import type { ChargersStepData, RingsStepData } from '../wizardData/types';

interface GetWizardData {
  accessory: ChargerModel | '';
  style?: RingStyle | '';
  finish?: RingFinish | '';
}

const getWizardData = ({
  accessory = '',
  style = '',
  finish = '',
}: GetWizardData): ChargersStepData | RingsStepData | null => {
  if (accessory) {
    return wizardData[accessory];
  }

  const _style: RingStyleEnum = !style ? RingStyleEnum.Heritage : style;
  const _finish: RingFinishEnum = !finish ? RingFinishEnum.Silver : finish;

  // Check if the style exists in the wizard data
  if (!Object.hasOwn(wizardData, _style as keyof typeof wizardData)) {
    return null;
  }

  const styleData = wizardData[_style as keyof typeof wizardData];

  // styleData should be a record of finishes for rings
  if (typeof styleData === 'object' && Object.hasOwn(styleData, _finish)) {
    const finishData = (
      styleData as unknown as Record<string, RingsStepData | null>
    )[_finish];
    return finishData ?? null;
  }

  return null;
};

export default getWizardData;
